module.exports = "pegasus_template/assets/f-icon2.png";